import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const AishIncomeHelperTexts: IntakeLabelCollection = {
  hasOtherSourcesIncome: {
    label: `Money you get from other sources that are not listed above.`,
    spousePartnerLabel: ``,
    onBehalfLabel: `Money they get from other sources that are not listed above.`,
    onBehalfSpousePartnerLabel: `Money they get from other sources that are not listed above.`,
  },
};

export const AishIncomeToolTips: IntakeLabelCollection = {
  incomeRowHeaderToolTip: {
    label: `<em>Average monthly net income</em> is the total of all income you earn after the subtracting of taxes and
          other deductions.`,
    spousePartnerLabel: `<em>Average monthly net income</em> is the total income you or your <<spouseLabel>> earn after
          taxes and other deductions have been subtracted.`,
    onBehalfLabel: `<em>Average monthly net income</em> is the total of all income <<oboName>> earns after the subtracting of taxes and
          other deductions.`,
    onBehalfSpousePartnerLabel: `<em>Average monthly net income</em> is the total income <<oboName>> or <<oboSpouseName>> earns after
          taxes and other deductions have been subtracted.`,
  },
  employmentIncome: {
    label: `Money you receive from: salary, wages, bonuses.`,
    spousePartnerLabel: ``,
    onBehalfLabel: `Money <<oboName>> receives from: salary, wages, bonuses.`,
    onBehalfSpousePartnerLabel: `Money <<oboName>> or <<oboSpouseName>> receives from: salary, wages, bonuses.`,
  },
  selfEmploymentIncome: {
    label: `Earned from a business you operate as a sole proprietor or with someone else as a partner
    including earnings from:
    <ul>
      <li>a business</li>
      <li>sales commission</li>
      <li>farming</li>
      <li>fishing activities</li>
    </ul>`,
    onBehalfLabel: `Earned from a business <<oboName>> operates as a sole proprietor including earnings from:
    <ul>
      <li>a business</li>
      <li>sales commission</li>
      <li>farming</li>
      <li>fishing activities</li>
    </ul>`,
    onBehalfSpousePartnerLabel: `Earned from a business <<oboName>> operates as a sole proprietor or with <<oboSpouseName>> including earnings from:
    <ul>
      <li>a business</li>
      <li>sales commission</li>
      <li>farming</li>
      <li>fishing activities</li>
    </ul>`,
  },
  employmentInsurance: {
    label: `Federal government benefits for: 
    <ul>
      <li>people who have lost a job through no fault of their own - (for example, due to work shortage or seasonal work)</li> 
      <li>people able and available to work, but can’t find a job</li>
      <li>parents on maternity or paternity leave</li>
    </ul>`,
  },
  canadaDisabilityBenefit: {
    label: `The Canada Disability Benefit (CDB) is a federal disability benefit program that provides up to $200 per month to eligible Canadians with disabilities aged 18 to 64. 
    To apply for the CDB, you need to file a tax return and be eligible for the Disability Tax Credit.`,
  },
  canadaPensionPlan: {
    label: `Federal government benefits including:
    <ul>
      <li>retirement pension (CPP)</li>
      <li>disability benefit (CPP-D)</li>
      <li>survivor’s pension</li>
    </ul>`,
  },
  oldAgeSecurity: {
    label: `Federal government benefits for seniors aged 65 and older and/or their spouses/partners, aged 60 to 64:
    <ul>
      <li>Old Age Security pension (OAS)</li>
      <li>Allowance for the survivor</li>
      <li>Guaranteed Income Supplement (GIS)</li>
      <li>Allowance for a GIS recipient’s spouse/partner</li>
    </ul>`,
  },
  pensionIncome: {
    label: `Income provided by a pension program like:
    <ul>
      <li>military pension</li>
      <li>provincial pension plans</li>
      <li>retirement compensation arrangements</li>
    </ul>`,
  },
  disabilityInsurance: {
    label: 'Payments from an insurance company when an employee is no longer able to earn a living.',
  },
  trustAccountIncome: {
    label: 'Include principal and interest payments.',
  },
  investmentIncome: {
    label: `<ul>
    <li>Interest payments</li>
    <li>Dividends</li>
    <li>Capital gains from selling a security or other assets</li>
    <li>Any other profit from any investment</li>
    </ul>`,
  },
  rentalIncome: {
    label: 'Income from a property or room you rent to someone else.',
    onBehalfLabel: `Income from a property or room that <<oboName>> rents to someone else.`,
    onBehalfSpousePartnerLabel: `Income from a property or room that <<oboName>> or <<oboSpouseName>> rents to someone else.`,
  },
  lifeInsuranceIncome: {
    label: 'Income paid to you as a beneficiary of a life insurance policy.',
    onBehalfLabel: `Income paid to <<oboName>> as a beneficiary of a life insurance policy.`,
    onBehalfSpousePartnerLabel: ``,
  },
  guaranteedSupplement: {
    label: '',
  },
  spousalSupport: {
    label: 'Money that one spouse/partner may have to pay the other spouse/partner due to a separation or divorce.',
  },
  wcbIncome: {
    label: 'Payment for workplace injuries or illnesses.',
  },
  otherSourcesOfIncome: {
    label: '',
  },
  specialPayment: {
    label: '',
  },
  whatAreSpecialPayments: {
    label: `Lump sum payments such as:
      <ul>
        <li>Cash gifts</li>
        <li>Inheritances</li>
        <li>Money from selling your primary residence</li>
        <li>Money from selling your primary and/or adapted vehicle</li>
        <li>Money you received if you were a victim of a criminal act or motor vehicle accident</li>
        <li>Insurance pay-out for your home/principal residence</li>
        <li>Insurance pay-out for your primary and/or adapted vehicle</li>
      </ul>`,
    onBehalfLabel: `Lump sum payments such as:
      <ul>
        <li>Cash gifts</li>
        <li>Inheritances</li>
        <li>Money from selling <<oboName>>'s primary residence</li>
        <li>Money from selling <<oboName>>'s primary and/or adapted vehicle</li>
        <li>Money <<oboName>> received if <<oboName>> was a victim of a criminal act or motor vehicle accident</li>
        <li>Insurance pay-out for <<oboName>>'s home/principal residence</li>
        <li>Insurance pay-out for <<oboName>>'s primary and/or adapted vehicle</li>
      </ul>`,
  },
};

export const AishIncomeLabels: IntakeLabelCollection = {
  incomeTypesIntro: {
    label: 'Fill in all income types you are currently receiving which apply to you.',
    spousePartnerLabel: 'Fill in all income types you and your <<spouseLabel>> are currently receiving.',
    onBehalfLabel: `Fill in all income types <<oboName>> is currently receiving.`,
    onBehalfSpousePartnerLabel: 'Fill in all income types <<oboName>> and <<oboSpouseName>> are currently receiving.',
  },
  applicantIncomeColumn: {
    label: 'Personal',
    onBehalfLabel: `<<oboName>>`,
  },
  spouseIncomeColumn: {
    label: '<<spouseLabelUpper>>',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>`,
  },
  applicantIncomeDocuments: {
    label: 'Personal income documents',
    onBehalfLabel: `<<oboName>>'s income documents`,
  },
  spouseIncomeDocuments: {
    label: '<<spouseLabelUpper>> income documents',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>'s income documents`,
  },
  uploaderDescription: {
    label: 'Based on the information you have provided the following documents are required to assess your application',
    onBehalfLabel: `Based on the information you have provided the following documents are required to assess <<oboName>>'s application`,
    onBehalfSpousePartnerLabel: `Based on the information you have provided the following documents are required to assess <<oboName>>'s application`,
  },
  hasOtherSourcesIncome: {
    label: 'Do you have other sources of income?',
    spousePartnerLabel: 'Do you or your <<spouseLabel>> have other sources of income?',
    onBehalfLabel: `Does <<oboName>> have other sources of income?`,
    onBehalfSpousePartnerLabel: `Does <<oboName>> or <<oboSpouseName>> have other sources of income?`,
  },
  otherSourcesType: {
    label: 'Description of income type',
  },
  otherSourcesFrequency: {
    label: 'How frequently do you receive this income type?',
    onBehalfLabel: `How frequently do they receive this income type?`,
    onBehalfSpousePartnerLabel: `How frequently do they receive this income type?`,
  },
  otherSourcesAmount: {
    label: 'How much?',
  },
  receivedSpecialPayment: {
    label: 'Have you received a special payment in the past 12 months?',
    spousePartnerLabel: 'Have you or your <<spouseLabel>> received a special payment in the past 12 months?',
    onBehalfLabel: `Has <<oboName>> received a special payment in the past 12 months?`,
    onBehalfSpousePartnerLabel: `Has <<oboName>> or <<oboSpouseName>> received a special payment in the past 12 months?`,
  },
  specialPaymentType: {
    label: 'Description of special payment',
  },
  specialPaymentFrequency: {
    label: 'How frequently do you receive this special payment?',
    onBehalfLabel: `How frequently do they receive this special payment?`,
    onBehalfSpousePartnerLabel: `How frequently do they receive this special payment?`,
  },
  specialPaymentAmount: {
    label: 'How much?',
  },
  appliedForCDB: {
    label: 'Have you applied for the Disability Tax Credit (DTC) and/or the Canada Disability Benefit (CDB)?',
    spousePartnerLabel:
      'Have you or your <<spouseLabel>> applied for the Disability Tax Credit (DTC) and/or the Canada Disability Benefit (CDB)?',
    onBehalfLabel: `Has <<oboName>> applied for the Disability Tax Credit (DTC) and/or the Canada Disability Benefit (CDB)?`,
    onBehalfSpousePartnerLabel: `Has <<oboName>> or <<oboSpouseName>> applied for the Disability Tax Credit (DTC) and/or the Canada Disability Benefit (CDB)?`,
  },
  incomeType: {
    label: 'Income type (average monthly net)',
  },
  personal: {
    label: 'Personal',
    thirdPersonLabel: '<<applicantName>>',
  },
  spouse: {
    label: 'Spouse/Partner',
    thirdPersonLabel: '<<spouseName>>',
  },
  type: null, // temporary placeholder
  frequency: null, // temporary placeholder
  amount: null, // temporary placeholder
};

//copy labels to special income actual fields
AishIncomeLabels.type = { ...AishIncomeLabels.otherSourcesType };
AishIncomeLabels.frequency = { ...AishIncomeLabels.otherSourcesFrequency };
AishIncomeLabels.amount = { ...AishIncomeLabels.otherSourcesAmount };
